<template>
  <QIcon :style="svgStyle">
    <component :is="icon" />
  </QIcon>
</template>
<script>
import { QIcon } from 'quasar';
import Accident from './Accident.vue';
import BreakdownAssist from './BreakdownAssist.vue';
import ComprehensiveInsurance from './ComprehensiveInsurance.vue';
import Fuel from './Fuel.vue';
import Maintainence from './Maintainence.vue';
import PresaleRate from './PresaleRate.vue';
import Registration from './Registration.vue';
import ReliefVehicle from './ReliefVehicle.vue';
import TollManagement from './TollManagement.vue';
import Tyres from './Tyres.vue';
export default {
  name: 'MainIcon',
  props: {
    size: {
      type: String,
      default: 'small'
    },
    icon: {
      type: String,
      reuqired: true
    }
  },
  data() {
    return {};
  },
  computed: {
    svgStyle() {
      if (this.size === 'large') {
        return {
          width: '80px',
          height: '60px'
        };
      }
      return {
        width: '34px',
        height: '24px'
      };
    }
  },
  components: {
    QIcon,
    Accident,
    BreakdownAssist,
    ComprehensiveInsurance,
    Fuel,
    Maintainence,
    PresaleRate,
    Registration,
    ReliefVehicle,
    TollManagement,
    Tyres
  }
};
</script>
